import { Model } from 'pinia-orm';
import InterviewTimeslot from './InterviewTimeslot';
import Interview from "./Interview";

export default class Timeslot extends Model {

    static get entity () {
        return 'timeslots'
    }

    static fields () {
        return {
            id: this.uid(),
            starttime: this.attr(null),
            endtime: this.attr(null),
            available: this.attr(true),
            multiple: this.attr(null),
            selected_application_id: this.attr(null),

            //relations
            interviews: this.belongsToMany(Interview, InterviewTimeslot, 'timeslots_id', 'interview_id'),
        }
    }
}
